import Image from "next/image";
import React from "react";
import SliderComponent from "./slider";

interface FutureProps {
  data?: any;
}
const HowWeWrok = ({ data }: FutureProps) => {
  return (
    <section className="relative bg-background-dark text-primary-text py-[56px] xl:py-25 md:py-[80px] overflow-hidden">
     
     <Image
        src="/images/about/top.png"
        width={571}
        height={571}
        alt="banner-vector"
        className="absolute w-[571px] h-[571px] top-[0] left-0 z-1 bg-cover bg-no-repeat bg-center "
        quality={80}
        loading="eager"
        priority
      />

      <Image
        src="/images/about/bottom.png"
        width={470}
        height={470}
        alt="banner-vector"
        className="absolute w-[470px] bottom-0  right-0 z-1 bg-cover bg-no-repeat bg-center  "
        quality={80}
        loading="eager"
        priority
      />
      <div className="container mx-auto px-4 text-center relative z-10">
        {/* Heading */}
        <h2 className="text-heading-1 font-bold text-primary-text-white mb-[10px] md:mt-[0px] max-w-[940px] mx-auto w-full">
          {data?.title}
        </h2>
        <p className="text-subtitle-2 font-normal text-secondary-text-white xl:mb-[40px] mb-[32px] max-w-[940px] mx-auto">
          {data?.short_title}
        </p>
      </div>
      <div className="container mx-auto sm:px-4 px-0-custom text-center relative z-10">
        <SliderComponent data={data} />
      </div>
      
    </section>
  );
};

export default HowWeWrok;
